export default "__VITE_ASSET__BJgHCcDG__"